import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { styled } from "@mui/styles";
import CustomButton from "../Button";

const StyledDialog = styled(Dialog)(() => ({
  "& .MuiDialogContent-root": {
    padding: "0 16px 16px 24px",
  },
  "& .MuiDialog-scrollPaper": {
    padding: "0 16px",
  },
  "& .MuiDialog-paperFullWidth": {
    minWidth: "100%",
  },
}));

const TransactionTimeoutAlert = ({
  isOpen,
  handleClose,
  testId = "transaction-timeout-alert",
  handleRedirectToDashboard,
}) => {
  return (
    <StyledDialog
      fullWidth
      open={isOpen}
      onClose={handleClose}
      data-cy={testId}
    >
      <DialogTitle>
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: "700",
            lineHeight: 1.4,
            color: "#000",
          }}
        >
          Session Expired
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: "8px 16px 16px" }}>
        <Typography>Your session expired due to inactivity.</Typography>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "0px 12px 24px",
          margin: 0,
          alignItems: "center",
        }}
      >
        <CustomButton
          text="Return to Dashboard"
          color="#fff"
          backgroundColor="#1278cc"
          onClick={handleRedirectToDashboard}
        />
      </DialogActions>
    </StyledDialog>
  );
};

export default TransactionTimeoutAlert;
